import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ 
      backgroundColor: 'var(--bg-card)', 
      borderTop: '1px solid var(--border-light)',
      padding: '60px 0 20px'
    }}>
      <div className="container-custom">
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
          gap: '40px',
          marginBottom: '40px'
        }}>
          {/* Company Info */}
          <div>
            <Logo />
            <p className="body-medium" style={{ 
              marginTop: '16px', 
              marginBottom: '24px',
              color: 'var(--text-secondary)',
              lineHeight: 1.6
            }}>
              Leading academic publishing house dedicated to advancing knowledge and fostering 
              scholarly communication worldwide.
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a href="#" style={{ color: 'var(--text-secondary)' }}>
                <Facebook size={20} />
              </a>
              <a href="#" style={{ color: 'var(--text-secondary)' }}>
                <Twitter size={20} />
              </a>
              <a href="#" style={{ color: 'var(--text-secondary)' }}>
                <Linkedin size={20} />
              </a>
              <a href="#" style={{ color: 'var(--text-secondary)' }}>
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '20px' }}>Quick Links</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to="/about" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                About Us
              </Link>
              <Link to="/books/published" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                Published Books
              </Link>
              <Link to="/conference/upcoming" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                Conferences
              </Link>
              <Link to="/authors" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                Authors
              </Link>
              <Link to="/awards" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                Awards
              </Link>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '20px' }}>Services</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to="/books/submit-chapter" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                Submit Chapter
              </Link>
              <Link to="/events" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                Workshops
              </Link>
              <Link to="/records" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                Research Records
              </Link>
              <Link to="/gallery" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                Gallery
              </Link>
              <Link to="/legends" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                Legends
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '20px' }}>Contact Us</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Mail size={18} color="var(--brand-primary)" />
                <span style={{ color: 'var(--text-secondary)' }}>esnpublications@gmail.com</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Phone size={18} color="var(--brand-primary)" />
                <span style={{ color: 'var(--text-secondary)' }}>+91 88381 73189 / +91 86677 67076</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <MapPin size={18} color="var(--brand-primary)" style={{ marginTop: '2px' }} />
                <span style={{ color: 'var(--text-secondary)' }}>
                  3/151 A, Muthuramalingapuram<br />
                 Kalloorani P.O, Tk, Aruppukkottai,<br />
                  Tamil Nadu-626105, India
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{ 
          borderTop: '1px solid var(--border-light)',
          paddingTop: '20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p style={{ 
            color: 'var(--text-secondary)', 
            fontSize: '0.9rem',
            margin: 0
          }}>
            © {currentYear} ESN Publications. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '24px' }}>
            <a href="#" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>
              Privacy Policy
            </a>
            <a href="#" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>
              Terms of Service
            </a>
            <a href="#" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;